module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "matterHeader"
  }, [_c('button', {
    staticClass: "btn btn-link",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-back"
  }), _c('span', [_vm._v("Back")])]), _vm._v(" "), (_vm.visatype) ? _c('h4', {
    staticClass: "panel-title"
  }, [_vm._v(_vm._s(_vm.matter.username) + " (" + _vm._s(_vm.matter.mattername) + ")")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel-nav",
    staticStyle: {
      "margin-right": "1em"
    }
  }, [_c('ul', {
    staticClass: "tab"
  }, [_c('li', {
    staticClass: "tab-item",
    class: {
      active: _vm.secKey === 'notes'
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.secKey = 'notes'
      }
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('li', {
    staticClass: "tab-item",
    class: {
      active: _vm.secKey === 'docs'
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.secKey = 'docs'
      }
    }
  }, [_vm._v("Documents")])]), _vm._v(" "), _vm._l((_vm.visatype.sections), function(section, key) {
    return _c('li', {
      staticClass: "tab-item",
      class: {
        active: _vm.secKey === key
      }
    }, [_c('a', {
      attrs: {
        "href": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.secKey = key
        }
      }
    }, [_vm._v(_vm._s(section.name))])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "matterHolder"
  }, [_c('div', [(_vm.secKey === 'notes') ? _c('div', [_c('quillEditor', {
    attrs: {
      "options": _vm.editorOptions
    },
    model: {
      value: (_vm.notes),
      callback: function($$v) {
        _vm.notes = $$v
      },
      expression: "notes"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.visatype && _vm.matter && _vm.section) ? _c('div', {
    staticClass: "panel-body"
  }, _vm._l((_vm.section.subsections), function(sub) {
    return _c('div', [(_vm.visible(sub)) ? _c('div', _vm._l((_vm.subcounts[sub.ref]), function(n) {
      return _c('div', {
        staticClass: "panel",
        staticStyle: {
          "margin-top": "10px"
        }
      }, [_c('div', {
        staticClass: "panel-header"
      }, [_c('div', {
        staticClass: "panel-title"
      }, [_c('h3', [_vm._v(_vm._s(sub.name) + " "), (n > 1) ? _c('span', [_vm._v("(" + _vm._s(n) + ")")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
        staticClass: "panel-body"
      }, _vm._l((sub.questions), function(q) {
        return _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (q.dependent ? _vm.visible(q) : true),
            expression: "q.dependent ? visible(q) : true"
          }],
          key: q.ref
        }, [(q.type === 'text') ? _c('textQ', {
          attrs: {
            "matter": _vm.matter,
            "question": q,
            "answers": _vm.answers,
            "num": n
          },
          on: {
            "saved": _vm.addAns,
            "edited": _vm.editAns
          }
        }) : (q.type === 'yn') ? _c('boolQ', {
          attrs: {
            "matter": _vm.matter,
            "question": q,
            "answers": _vm.answers,
            "num": n
          },
          on: {
            "saved": _vm.addAns,
            "edited": _vm.editAns
          }
        }) : (q.type === 'select') ? _c('selectQ', {
          attrs: {
            "matter": _vm.matter,
            "question": q,
            "answers": _vm.answers,
            "num": n
          },
          on: {
            "saved": _vm.addAns,
            "edited": _vm.editAns
          }
        }) : (q.type === 'date') ? _c('dateQ', {
          attrs: {
            "matter": _vm.matter,
            "question": q,
            "answers": _vm.answers,
            "num": n
          },
          on: {
            "saved": _vm.addAns,
            "edited": _vm.editAns
          }
        }) : (q.type === 'number') ? _c('numberQ', {
          attrs: {
            "matter": _vm.matter,
            "question": q,
            "answers": _vm.answers,
            "num": n
          },
          on: {
            "saved": _vm.addAns,
            "edited": _vm.editAns
          }
        }) : (q.type === 'textarea') ? _c('textareaQ', {
          attrs: {
            "matter": _vm.matter,
            "question": q,
            "answers": _vm.answers,
            "num": n
          },
          on: {
            "saved": _vm.addAns,
            "edited": _vm.editAns
          }
        }) : (q.type === 'country') ? _c('countryQ', {
          attrs: {
            "matter": _vm.matter,
            "question": q,
            "answers": _vm.answers,
            "num": n
          },
          on: {
            "saved": _vm.addAns,
            "edited": _vm.editAns
          }
        }) : (q.type === 'language') ? _c('languageQ', {
          attrs: {
            "matter": _vm.matter,
            "question": q,
            "answers": _vm.answers,
            "num": n
          },
          on: {
            "saved": _vm.addAns,
            "edited": _vm.editAns
          }
        }) : _vm._e()], 1)
      }), 0), _vm._v(" "), (sub.repeatable && n === _vm.subcounts[sub.ref]) ? _c('button', {
        staticClass: "btn btn-sm btn-primary float-right",
        staticStyle: {
          "width": "155px"
        },
        on: {
          "click": function($event) {
            return _vm.addSub(sub)
          }
        }
      }, [_c('i', {
        staticClass: "icon icon-plus"
      }), _vm._v("Add another\n              ")]) : _vm._e()])
    }), 0) : _vm._e()])
  }), 0) : (_vm.secKey === 'docs') ? _c('div', _vm._l((_vm.visatype.doctypes), function(doctype) {
    return _c('div', {
      staticClass: "panel panel-docs"
    }, [_c('div', {
      staticClass: "panel-header"
    }, [_c('div', {
      staticClass: "panel-title"
    }, [_vm._v("\n              " + _vm._s(doctype.name) + "\n              "), (!_vm.files[doctype.ref] || !_vm.files[doctype.ref].length) ? _c('span', {
      staticClass: "label label-default"
    }, [_vm._v("\n                no uploads\n              ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "panel-body"
    }, _vm._l((_vm.files[doctype.ref]), function(file) {
      return _c('div', {
        staticClass: "tile tile-centered"
      }, [_c('div', {
        staticClass: "tile-icon"
      }, [_c('button', {
        staticClass: "btn btn-primary"
      }, [_c('i', {
        staticClass: "icon",
        class: [file.accepted ? 'icon-check' : 'icon-cross']
      })])]), _vm._v(" "), _c('div', {
        staticClass: "tile-content"
      }, [_c('div', {
        staticClass: "tile-title"
      }, [_vm._v(_vm._s(file.name))]), _vm._v(" "), _c('div', {
        staticClass: "tile-subtitle text-gray"
      }, [_vm._v(_vm._s(_vm.dateStr(file.date)))])]), _vm._v(" "), _c('div', {
        staticClass: "tile-action"
      }, [_c('div', {
        staticClass: "form-group"
      }, [_c('label', {
        staticClass: "form-switch"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (file.accepted),
          expression: "file.accepted"
        }],
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": Array.isArray(file.accepted) ? _vm._i(file.accepted, null) > -1 : (file.accepted)
        },
        on: {
          "change": [function($event) {
            var $$a = file.accepted,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(file, "accepted", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(file, "accepted", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(file, "accepted", $$c)
            }
          }, _vm.saveMatter]
        }
      }), _vm._v(" "), _c('i', {
        staticClass: "form-icon"
      }), _vm._v(" Accept\n                  ")])])])])
    }), 0)])
  }), 0) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a864838"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/matter.vue
// module id = 479
// module chunks = 1